<template>
    <span class="align-middle">
        <a v-if="userCanAccessBillingPortal" href="#" @click="$refs.billingView.open()" data-dismiss="modal"
            >Manage your subscription plan.</a
        >
        <span v-else>Contact your administrator to upgrade your subscription plan</span>.
        <billing-view ref="billingView"></billing-view>
    </span>
</template>

<script>
import BillingView from "@/components/BillingView"

export default {
    name: "UpgradePlanPrompt",
    components: {
        BillingView,
    },
    computed: {
        userCanAccessBillingPortal() {
            return this.organizationBillingEnabled && this.userIsOrganizationAdmin
        },
        organizationBillingEnabled() {
            return this.$store.getters.organizationBillingEnabled
        },
        userIsOrganizationAdmin() {
            return this.$store.getters.userIsOrganizationAdmin
        },
    },
}
</script>

<style>
</style>